// removed by extract-text-webpack-plugin
module.exports = {"container":"bm_g"};


//////////////////
// WEBPACK FOOTER
// ./app/src/components/EventDetailPage/styles.module.css
// module id = 1311
// module chunks = 27